import type { CSSObject } from '@emotion/react'
import type { PopoverWidth } from '@mantine/core'
import { Card } from 'components/MapCard/components/Card'
import { OverlayPopover } from 'components/MapCard/components/OverlayPopover'
import type { ReactNode } from 'react'
import { HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD } from 'settings/hubConnectorEnvironment'
import { useIsWideScreen } from 'utils/useIsWideScreen'

export const MapCard = (props: {
  children: ReactNode
  footer?: ReactNode
  latLng: google.maps.LatLngLiteral
  onClose: () => void
  title: string
  titleIcons?: ReactNode
  targetCSS?: CSSObject
  cardCSS?: CSSObject
  popoverWidth?: PopoverWidth
}) => {
  const isWideScreen = useIsWideScreen()

  if (HUB_CONNECTOR_ENVIRONMENT_IS_SWAGWORLD || isWideScreen) {
    return (
      <OverlayPopover
        title={props.title}
        titleIcons={props.titleIcons}
        latLng={props.latLng}
        onClose={props.onClose}
        footer={props.footer}
        targetCSS={props.targetCSS}
        popoverWidth={props.popoverWidth ?? 400}
      >
        {props.children}
      </OverlayPopover>
    )
  }

  return (
    <Card
      title={props.title}
      titleIcons={props.titleIcons}
      onClose={props.onClose}
      footer={props.footer}
      cardCSS={props.cardCSS}
    >
      {props.children}
    </Card>
  )
}
